export const DocumentReviewStatus = Object.freeze({
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
});

export const ApplicantDocumentType = Object.freeze({
  NYSC: "NYSC",
  QUALIFICATION: "QUALIFICATION",
  PROGRAMME: "PROGRAMME",
});

const STATUS_COLORS = Object.freeze({
  PENDING: "warning",
  APPROVED: "success",
  REJECTED: "error",
});

export function documentReviewStatusColor(status) {
  return STATUS_COLORS[status] || "grey";
}
